/**
 * Carrusel de venta cruzada del carrito lateral (tema Split - Viani).
 *
 * El carrito lateral se re-renderiza por AJAX: el tema reemplaza el innerHTML de
 * #AjaxCartForm en cada cambio de cantidad y también al agregar productos. Los
 * <script> inyectados por innerHTML no se ejecutan, así que toda la lógica vive
 * en este archivo (cargado una sola vez en el layout) y se re-engancha con un
 * MutationObserver.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-vcu]'));
  }

  function getStep(track) {
    var slide = track.querySelector('.vcu__slide');
    if (!slide) return 0;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 10;
    return slide.getBoundingClientRect().width + gap;
  }

  function maxScroll(track) {
    return Math.max(0, track.scrollWidth - track.clientWidth);
  }

  function paint(root) {
    var track = root.querySelector('[data-vcu-track]');
    var nav = root.querySelector('[data-vcu-nav]');
    var prev = root.querySelector('[data-vcu-prev]');
    var next = root.querySelector('[data-vcu-next]');
    if (!track) return;

    var overflows = maxScroll(track) > 4;

    if (nav) nav.hidden = !overflows;
    if (!overflows) return;

    var left = track.scrollLeft;
    if (prev) prev.disabled = left <= 2;
    if (next) next.disabled = left >= maxScroll(track) - 2;
  }

  function goTo(track, direction) {
    var target = track.scrollLeft + direction * getStep(track);
    var max = maxScroll(track);
    target = Math.max(0, Math.min(target, max));

    if (reduceMotion) {
      track.scrollLeft = target;
      return;
    }

    // iOS Safari: scroll-snap "mandatory" cancela scrollTo() y volvería al slide
    // actual; se apaga el snap mientras dura la animación y se restaura al final.
    var start = track.scrollLeft;
    var delta = target - start;
    if (Math.abs(delta) < 1) return;

    var started = null;
    track.style.scrollSnapType = 'none';

    if (track.__vcuFrame) {
      window.cancelAnimationFrame(track.__vcuFrame);
    }

    function frame(now) {
      if (started === null) started = now;
      var progress = Math.min((now - started) / 420, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      track.scrollLeft = start + delta * eased;

      if (progress < 1) {
        track.__vcuFrame = window.requestAnimationFrame(frame);
      } else {
        track.__vcuFrame = null;
        track.style.scrollSnapType = '';
      }
    }

    track.__vcuFrame = window.requestAnimationFrame(frame);
  }

  function initRoot(root) {
    var track = root.querySelector('[data-vcu-track]');
    if (!track || root.dataset.vcuReady === '1') return;

    root.dataset.vcuReady = '1';

    track.addEventListener('scroll', function () { paint(root); }, { passive: true });
    window.addEventListener('resize', function () { paint(root); });

    // El cajón se abre después del primer render (display:none => ancho 0),
    // así que las flechas se recalculan cuando el track obtiene tamaño real.
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () { paint(root); });
      ro.observe(track);
    }

    paint(root);
  }

  function initAll() {
    roots().forEach(initRoot);
  }

  function setStatus(root, message) {
    var el = root.querySelector('[data-vcu-status]');
    if (el) el.textContent = message || '';
  }

  function addToCart(button) {
    var root = button.closest('[data-vcu]');
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var label = button.querySelector('[data-vcu-label]') || button;
    var original = label.textContent;
    var title = button.getAttribute('data-product-title') || 'Producto';

    button.disabled = true;
    button.classList.add('is-loading');
    label.textContent = 'Agregando…';
    if (root) setStatus(root, '');

    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) {
            throw new Error(body.description || body.message || 'No se pudo agregar el producto.');
          }
          return body;
        });
      })
      .then(function () {
        label.textContent = 'Agregado';

        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
          return;
        }
        window.location.reload();
      })
      .catch(function (error) {
        button.disabled = false;
        button.classList.remove('is-loading');
        label.textContent = original;
        if (root) setStatus(root, error.message || 'No se pudo agregar ' + title + '.');
      });
  }

  if (!window.__vcuClickBound) {
    window.__vcuClickBound = true;

    document.addEventListener('click', function (event) {
      var add = event.target.closest('[data-vcu-add]');
      if (add) {
        event.preventDefault();
        addToCart(add);
        return;
      }

      var prev = event.target.closest('[data-vcu-prev]');
      var next = event.target.closest('[data-vcu-next]');
      if (!prev && !next) return;

      var root = (prev || next).closest('[data-vcu]');
      var track = root && root.querySelector('[data-vcu-track]');
      if (!track) return;

      event.preventDefault();
      goTo(track, prev ? -1 : 1);
    });
  }

  if (!window.__vcuObserverBound) {
    window.__vcuObserverBound = true;

    // El cajón se abre con display:none -> el primer paint mide 0. Al abrirlo
    // (o al cambiar de tamaño) se recalculan flechas y overflow.
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]')) return;
      window.setTimeout(function () {
        roots().forEach(function (root) { paint(root); });
      }, 320);
    });

    var pendingObserver = null;
    var observer = new MutationObserver(function () {
      if (pendingObserver) return;
      pendingObserver = window.requestAnimationFrame(function () {
        pendingObserver = null;
        initAll();
      });
    });

    var startObserver = function () {
      var host = document.getElementById('AjaxCartForm') || document.getElementById('site-cart-sidebar');
      if (host) observer.observe(host, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserver);
    } else {
      startObserver();
    }

    document.addEventListener('cart-updated', initAll);
    document.addEventListener('shopify:section:load', initAll);
  }

  initAll();
})();
